import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import FlagProvider from './global_context/FlagProvider'
import { AuthProvider } from './auth/AuthContext'
import { SessionProfileProvider } from './auth/SessionProfileProvider'
import './css/index.css'
import './css/styles.scss'

const container = document.getElementById('app')
const root = createRoot(container)

root.render(
  <SessionProfileProvider>
    <FlagProvider>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </FlagProvider>
  </SessionProfileProvider>
)
